import { Box } from '@dixa/lib-shared-habla';

import { presenceApi } from 'apis/presence';
import { LegacyPresenceListSections } from 'components/presence/components/legacyPresenceListSections';
import { PresenceListSections } from 'components/presence/components/presenceListSections';
import { PresenceSectionWarning } from 'components/presence/components/presenceSectionWarning';
import { usePresenceMembers } from 'components/presence/hooks/usePresenceMembers';
import { useFeatureFlag } from 'utils/featureFlagging/useFeatureFlag';
import { useAppSelector } from 'utils/redux/useAppSelector';
import { useCurrentUser } from 'utils/user';

import styles from './presenceList.module.scss';

export const PresenceList = (): JSX.Element => {
  const { user } = useCurrentUser();
  const flags = useFeatureFlag([
    'custom-away-status',
    'legacy-presence-sidebar',
  ]);

  const { awayStatuses } = presenceApi.useReadAwayStatusesQuery(
    { isDeactivated: false },
    {
      skip: !flags.customAwayStatus,
      selectFromResult: ({ data, ...rest }) => ({
        ...rest,
        awayStatuses: data?.data.customAwayStatuses ?? [],
      }),
    },
  );

  const { members, teams, isLoading, isError } = usePresenceMembers();

  const isOffline = useAppSelector((state) => state.presence.meta.offline);
  const hasFailed = isError && members.length === 0;

  return (
    <Box padding="0 200">
      <ul className={styles.list}>
        {hasFailed ? (
          <PresenceSectionWarning title="Presence loading failed.." />
        ) : isOffline ? (
          <PresenceSectionWarning title="You are offline" />
        ) : flags.legacyPresenceSidebar ? (
          <LegacyPresenceListSections
            members={members}
            profile={user}
            awayStatuses={awayStatuses}
            isLoading={isLoading}
          />
        ) : (
          <PresenceListSections
            profile={user}
            awayStatuses={awayStatuses}
            members={members}
            teams={teams}
            isLoading={isLoading}
            isError={isError}
          />
        )}
      </ul>
    </Box>
  );
};
